import { PasswordReset } from '../../auth';

/** Reset-link landing (/reset-password?token=...); the adapter supplies the form. */
export function ResetPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg relative z-10">
      <PasswordReset />
    </div>
  );
}
